import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '@app/core';

@Pipe({
  name: 'toArabic',
  standalone: true,
  pure: false
})
export class ToArabicPipe implements PipeTransform {
  constructor(private languageService?: LanguageService) {}

  transform(value: any, args?: any): any {
    if (!this.languageService.isEnglish) {
      if (/\d/g.test(value)) {
        let arabicNumbers = ['۰', '۱', '۲', '۳', '٤', '٥', '٦', '۷', '۸', '۹'];
        let converted = value.toString().replace(/[0-9]/g, function(w: any) {
          return arabicNumbers[+w];
        });
        converted = converted.replace('.', ',');
        return converted;
      } else return value;
    }

    return value;
  }

  transformAddUnit(value: any, args?: any) {
    if (!this.languageService.isEnglish) {
      if (/\d/g.test(value)) {
        let arabicNumbers = ['۰', '۱', '۲', '۳', '٤', '٥', '٦', '۷', '۸', '۹'];
        let converted = value.replace(/[0-9]/g, function(w: any) {
          return arabicNumbers[+w];
        });
        if (converted.split('-').length == 1 && converted.split('/').length == 1 && converted.split(':').length == 1) {
          if (
            args == 'max_weight' ||
            args == 'weight' ||
            args == 'total_weight' ||
            /[\u0600-\u06FF\u0750-\u077F]/.test(args)
          )
            converted = `${converted}  طن`;
        }

        return converted;
      } else return value;
    }
    return value;
  }
}
